var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFlexible(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5017 4.09277C14.9931 4.0315 15.4932 4 16 4C16.5068 4 17.0069 4.0315 17.4983 4.09277L17.1683 6.73894C16.7862 6.69129 16.3963 6.66667 16 6.66667C15.6037 6.66667 15.2138 6.69129 14.8317 6.73894L14.5017 4.09277ZM4 16C4 15.4932 4.0315 14.9931 4.09277 14.5017L6.73894 14.8317C6.69129 15.2138 6.66667 15.6037 6.66667 16C6.66667 16.3963 6.69129 16.7862 6.73894 17.1683L4.09277 17.4983C4.0315 17.0069 4 16.5068 4 16ZM25.3333 16C25.3333 15.6037 25.3087 15.2138 25.2611 14.8317L27.9072 14.5017C27.9685 14.9931 28 15.4932 28 16C28 16.5068 27.9685 17.0069 27.9072 17.4983L25.2611 17.1683C25.3087 16.7862 25.3333 16.3963 25.3333 16ZM14.8317 25.2611C15.2138 25.3087 15.6037 25.3333 16 25.3333C16.3963 25.3333 16.7862 25.3087 17.1683 25.2611L17.4983 27.9072C17.0069 27.9685 16.5068 28 16 28C15.4932 28 14.9931 27.9685 14.5017 27.9072L14.8317 25.2611Z",
    fill: "#6D758F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 8C4 5.79086 5.79086 4 8 4C10.2091 4 12 5.79086 12 8C12 10.2091 10.2091 12 8 12C5.79086 12 4 10.2091 4 8Z",
    fill: "#6D758F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 24C4 21.7909 5.79086 20 8 20C10.2091 20 12 21.7909 12 24C12 26.2091 10.2091 28 8 28C5.79086 28 4 26.2091 4 24Z",
    fill: "#6D758F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 24C20 21.7909 21.7909 20 24 20C26.2091 20 28 21.7909 28 24C28 26.2091 26.2091 28 24 28C21.7909 28 20 26.2091 20 24Z",
    fill: "#6D758F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 8C20 5.79086 21.7909 4 24 4C26.2091 4 28 5.79086 28 8C28 10.2091 26.2091 12 24 12C21.7909 12 20 10.2091 20 8Z",
    fill: "#6D758F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFlexible);
export default __webpack_public_path__ + "static/media/icon-flexible.7bb4feb4f03e18972585dde9498cf2a2.svg";
export { ForwardRef as ReactComponent };